module.exports = __webpack_public_path__ + "img/21.05dcb34a.png";